import React, { useEffect, useState } from 'react';
import clsx from "clsx";
import { BreadCrumbNew } from "../BreadCrumbNew";
import customStyles from "../../../../assets/styles/customStyles";

const MainHeader = (props) => {
    const [offset, setOffset] = useState(0);

    const classes = customStyles();
    useEffect(() => {
        const onScroll = () => setOffset(window.pageYOffset);
        window.removeEventListener('scroll', onScroll);
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);


    return (
        <div className={clsx(classes.mainHeader, { [classes.scrollHeader]: offset > 10 })} id="mainHeader">            
            {/* <div className={classes.notificationBar}>Enable notification <Link to={'#'} onClick={() => enableNotification()}>Click here</Link></div> */}
            <BreadCrumbNew {...props} />
        </div>
    )
}

export default MainHeader